import { useState } from "react";
import axios from "axios";
import { notifyError } from "./CustomNotifcations";

export default function useDownloadFile(dispatch) {
  const [loader, setLoader] = useState(false);

  // Helper: safely convert anything to array
  const toArray = (val) => {
    if (Array.isArray(val)) return val;
    if (!val) return [];
    return [val];
  };

  // Build query string for GET request
  const buildQuery = (filters = {}) => {
    const qs = new URLSearchParams();

    if (filters.deliveryNoteNumber) qs.append("deliveryNoteNumber", filters.deliveryNoteNumber);
    if (filters.deliveryNoteRefNumber) qs.append("deliveryNoteRefNumber", filters.deliveryNoteRefNumber);
    if (filters.plateNumber) qs.append("plateNumber", filters.plateNumber);
    if (filters.stationCity) qs.append("stationCity", filters.stationCity);
    if (filters.from) qs.append("from", filters.from);
    if (filters.to) qs.append("to", filters.to);

    qs.append("invoiceStatus", filters.invoiceStatus ?? 1);
    // qs.append("activeAccount", 1);

    toArray(filters.vehicleId).forEach(id => qs.append("vehicleId", id));
    toArray(filters.selectedVehicleId).forEach(id => qs.append("vehicleId", id));
    toArray(filters.areaId).forEach(id => qs.append("areaId", id));
    toArray(filters.selectedAreaId).forEach(id => qs.append("areaId", id));

    const invoiceMades = toArray(filters.invoicemades);
    if (invoiceMades.length > 0) {
      invoiceMades.forEach(id => qs.append("invoiceMade", id));
    } else {
      qs.append("invoiceMade", 0);
      // qs.append("invoiceMade", 1);
    }

    toArray(filters.garageVerticals).forEach(v => qs.append("dnTypes", v));

    if (filters.area) qs.append("stationCity", filters.area);

    return qs.toString();
  };

  // Public function to trigger download
  const downloadInvoice = async (data, type = "xlxs") => {
    setLoader(true);
    try {
      const queryString = buildQuery(data);
      const accept = type === "pdf" ? "application/pdf" : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      const extension = type === "pdf" ? "pdf" : "xlsx";

      const apiUrl = `/api/deliverynotes/exportdnforpoinvoices?${queryString}`;

      const response = await axios.get(apiUrl, {
        responseType: "blob",
        headers: {
          Accept: accept,
        },
        credentials: "include",
      });

      saveData(response.data, `DN-SO.${extension}`);
    } catch (err) {
      console.error("Download error:", err);
      dispatch(notifyError("Unexpected error while downloading file"));
    } finally {
      setLoader(false);
    }
  };

  // Save the blob to a file
  const saveData = (blob, filename) => {
    if (window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, filename);
    } else {
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      setTimeout(() => {
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }, 0);
    }
  };

  return { downloadInvoice, loader };
}
